/** スポット 1 件を Google マップで開くリンク */

import { ExternalLink } from 'lucide-react'

import type { RoutePlanItem } from '@/api/types/route-plan'

import { placeMapsUrl } from '../lib'

type Props = {
  item: Pick<RoutePlanItem, 'name' | 'latitude' | 'longitude' | 'google_place_id'>
}

export const PlaceMapsLink = ({ item }: Props) => (
  <a
    href={placeMapsUrl(item)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`${item.name} を Google マップで開く`}
    onClick={(e) => e.stopPropagation()}
    className="flex size-7 shrink-0 items-center justify-center rounded-md text-muted-foreground active:bg-accent"
  >
    <ExternalLink size={15} />
  </a>
)
